import { ReactElement } from 'react';
import { StyledBackButton } from './styles';
import { ArrowLeftIconNew } from '@root/src/assets/images';
import Lang from '@lang/en';

interface BackButtonProps {
  to: string;
  'data-testid'?: string;
}

const BackButton = ({ to, ...rest }: BackButtonProps): ReactElement => {
  return (
    <StyledBackButton to={to} data-testid={rest['data-testid']}>
      <ArrowLeftIconNew />
      <span>{Lang.back}</span>
    </StyledBackButton>
  );
};

export default BackButton;
